import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAdminUuid } from '../../features/auth/authSlice';
import { getRoleJSON } from '../utils';

// The signed-in employee's roles (getRoleJSON), for Work pages that show a
// link or panel belonging to another area. null until loaded — callers treat
// that as "no", so a link into a page the person can't open never flashes up
// first and then vanishes.
export default function useRoleJSON() {
  const uuid = useSelector(selectAdminUuid);
  const [roleJSON, setRoleJSON] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (uuid) getRoleJSON(uuid).then(rj => { if (!cancelled) setRoleJSON(rj); });
    return () => { cancelled = true; };
  }, [uuid]);
  return roleJSON;
}
